export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10421.3f9d4bd1.jpg";